<template>
  <div>
    <p v-show="hasUpdated" class="cc-success">
      {{ feedbackMessage }}
      <BIconX @click="closeSuccessMessage" style="cursor:pointer" />
    </p>

    <form v-if="userHasAddress" class="cc-form">
      <div class="field">
        <input
          class="input"
          :class="{ 'input--error': $v.card.nickname.$error }"
          type="text"
          placeholder="Apelido do cartão (ex: Roxinho)"
          v-model="$v.card.nickname.$model"
        />
        <p
          class="field-error"
          v-if="$v.card.nickname.$error && !$v.card.nickname.required"
        >
          Campo obrigatório
        </p>
      </div>

      <div class="field">
        <input
          class="input"
          :class="{ 'input--error': $v.card.holder_name.$error }"
          type="text"
          placeholder="Nome do titular (como no cartão)"
          v-model="$v.card.holder_name.$model"
        />
        <p
          class="field-error"
          v-if="$v.card.holder_name.$error && !$v.card.holder_name.required"
        >
          Campo obrigatório
        </p>
      </div>

      <div class="cc-row">
        <div class="field">
          <input
            class="input num"
            :class="{ 'input--error': $v.card.holder_cpf.$error }"
            type="tel"
            placeholder="CPF do titular"
            v-mask="'###.###.###-##'"
            v-model="$v.card.holder_cpf.$model"
          />
          <p class="field-error" v-if="$v.card.holder_cpf.$error">
            <template v-if="!$v.card.holder_cpf.required">
              Campo obrigatório
            </template>
            <template v-else-if="!$v.card.holder_cpf.cpf">
              CPF inválido
            </template>
          </p>
        </div>

        <div class="field">
          <input
            class="input num"
            :class="{ 'input--error': $v.card.holder_birthdate.$error }"
            type="tel"
            placeholder="Nascimento (DD/MM/AAAA)"
            v-mask="'##/##/####'"
            v-model="$v.card.holder_birthdate.$model"
          />
          <p
            class="field-error"
            v-if="
              $v.card.holder_birthdate.$error &&
                !$v.card.holder_birthdate.required
            "
          >
            Campo obrigatório
          </p>
        </div>
      </div>

      <div class="cc-row cc-row--ddd">
        <div class="field">
          <input
            class="input num"
            :class="{ 'input--error': $v.card.area_code.$error }"
            type="tel"
            placeholder="DDD"
            v-mask="'##'"
            v-model="$v.card.area_code.$model"
          />
          <p
            class="field-error"
            v-if="$v.card.area_code.$error && !$v.card.area_code.required"
          >
            Campo obrigatório
          </p>
        </div>

        <div class="field">
          <input
            class="input num"
            :class="{ 'input--error': $v.card.phone_number.$error }"
            type="tel"
            placeholder="Telefone do titular"
            v-mask="'#####-####'"
            v-model="$v.card.phone_number.$model"
          />
          <p
            class="field-error"
            v-if="$v.card.phone_number.$error && !$v.card.phone_number.required"
          >
            Campo obrigatório
          </p>
        </div>
      </div>

      <div class="field">
        <input
          class="input num"
          :class="{ 'input--error': $v.card.number.$error }"
          type="tel"
          placeholder="Número do cartão"
          v-mask="'#### #### #### ####'"
          v-model="$v.card.number.$model"
        />
        <p class="field-error" v-if="$v.card.number.$error">
          <template v-if="!$v.card.number.required">Campo obrigatório</template>
          <template v-else-if="!$v.card.number.creditCardNumber">
            Número inválido
          </template>
        </p>
      </div>

      <div class="cc-row">
        <div class="field">
          <input
            class="input num"
            :class="{ 'input--error': $v.card.expiration.$error }"
            type="tel"
            placeholder="Validade (MM/AA)"
            v-model="$v.card.expiration.$model"
            v-mask="'##/##'"
          />
          <p class="field-error" v-if="$v.card.expiration.$error">
            <template v-if="!$v.card.expiration.required">
              Campo obrigatório
            </template>
            <template
              v-else-if="
                !$v.card.expiration.validExpirationDate &&
                  card.expiration.length == 5
              "
            >
              Data inválida
            </template>
          </p>
        </div>

        <div class="field">
          <input
            class="input num"
            :class="{ 'input--error': $v.card.cvc.$error }"
            type="number"
            placeholder="CVC"
            v-mask="['###', '####']"
            v-model="$v.card.cvc.$model"
          />
          <p class="field-error" v-if="$v.card.cvc.$error">
            <template v-if="!$v.card.cvc.required">Campo obrigatório</template>
            <template
              v-else-if="!$v.card.cvc.cvcIsValid && card.cvc.length >= 3"
            >
              CVC inválido
            </template>
          </p>
        </div>
      </div>

      <button
        class="btn btn--primary"
        style="width:100%;margin-top:var(--space-2)"
        @click.prevent="saveCreditCard()"
        :disabled="canSaveCreditCard"
      >
        Salvar cartão
      </button>
    </form>
  </div>
</template>

<script>
import { userMethods } from "./../state/helpers";
import { required } from "vuelidate/lib/validators";
import { cpf } from "./../utils/validations/cpf";

export default {
  name: "CreditCard",
  props: { title: { type: String, default: "" } },
  data() {
    return {
      loading: false,
      card: {
        nickname: "",
        number: "",
        cvc: "",
        expiration: "",
        holder_name: "",
        holder_cpf: "",
        holder_birthdate: "",
        area_code: "",
        phone_number: ""
      },
      hasUpdated: false
    };
  },
  validations: {
    card: {
      nickname: { required },
      number: {
        required,
        creditCardNumber: function(creditCardNumber) {
          const digits = creditCardNumber.replace(/\s/g, "");
          return (
            (window.Iugu &&
              window.Iugu.utils &&
              window.Iugu.utils.validateCreditCardNumber(digits)) ||
            false
          );
        }
      },
      cvc: {
        required,
        cvcIsValid: function(cvc) {
          const digits = this.card.number.replace(/\s/g, "");
          const brand =
            window.Iugu &&
            window.Iugu.utils &&
            window.Iugu.utils.getBrandByCreditCardNumber(digits);
          return (
            (window.Iugu &&
              window.Iugu.utils &&
              brand &&
              window.Iugu.utils.validateCVV(cvc, brand)) ||
            false
          );
        }
      },
      expiration: {
        required,
        validExpirationDate: function(value) {
          if (value.length === 5) {
            const [month, year] = value.split("/");
            return (
              (window.Iugu &&
                window.Iugu.utils &&
                window.Iugu.utils.validateExpiration(month, "20" + year)) ||
              false
            );
          }
          return false;
        }
      },
      holder_name: { required },
      area_code: { required },
      phone_number: { required },
      holder_cpf: { required, cpf },
      holder_birthdate: { required }
    }
  },
  methods: {
    ...userMethods,
    async saveCreditCard() {
      if (!this.$v.card.$invalid) {
        try {
          this.loading = true;
          const token = await this.tokenizeCreditCard(this.card);
          const credit_card_payload = {
            nickname: this.card.nickname,
            token: token.token,
            set_as_default: false
          };
          const { data } = await this.addCreditCard(credit_card_payload);
          this.hasUpdated = true;
          this.$emit("pushNewCreditCard", data);
          this.$v.$reset();
          this.clearCard();
        } catch (error) {
          swal.fire({
            icon: "error",
            title: "Erro ao processar a transação",
            text: "Tente novamente mais tarde!"
          });
        } finally {
          this.loading = false;
        }
      }
    },
    closeSuccessMessage() {
      this.hasUpdated = false;
    },
    clearCard() {
      this.card = {
        nickname: "",
        number: "",
        cvc: "",
        expiration: "",
        holder_name: "",
        holder_cpf: "",
        holder_birthdate: ""
      };
    }
  },
  computed: {
    canSaveCreditCard() {
      return this.$v.card.$invalid || this.loading;
    },
    feedbackMessage() {
      return "Cartao cadastrado com sucesso!";
    },
    userHasAddress() {
      return !!this.$store.state.user.currentUser.address.id;
    }
  }
};
</script>

<style lang="scss" scoped>
.cc-form {
  display: flex;
  flex-direction: column;
  gap: var(--space-3);
}

.cc-row {
  display: grid;
  grid-template-columns: 1fr 1fr;
  gap: var(--space-3);
}

.cc-row--ddd {
  grid-template-columns: 80px 1fr;
}

.field {
  display: flex;
  flex-direction: column;
  gap: var(--space-1);
}

.input--error {
  border-color: var(--color-danger) !important;
}

.field-error {
  font-size: var(--font-size-xs);
  color: var(--color-danger);
  margin: 0;
}

.cc-success {
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: var(--space-2);
  padding: var(--space-3) var(--space-4);
  background: #ecfdf5;
  color: #065f46;
  border-radius: var(--radius-md);
  font-size: var(--font-size-sm);
  font-weight: var(--fw-semibold);
  margin-bottom: var(--space-4);
}
</style>
